import React, { useEffect, useState } from 'react';
import sanitalizeHtml from './sanitalizeHtml';

const RenderRawHtml = ({ children }: any) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    setHtml(sanitalizeHtml(children));
  }, [setHtml, sanitalizeHtml, children]);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export default RenderRawHtml;
